import {Graphics, Sprite} from 'pixi.js';
import {StaticData} from '../../../../../../data/StaticData';

export class ActivePlayerStroke extends Sprite
{
    stroke: Graphics;

    constructor() {
        super();

        this.stroke = new Graphics();
        this.addChild(this.stroke);

    }

    updateColor(colorHex: number) {
        this.stroke.clear();
        this.stroke.lineStyle(StaticData.videoSeatBorderWidth, colorHex);
        this.stroke.drawRoundedRect(
            -StaticData.videoSeatActivePlayerStrokeMargin,
            -StaticData.videoSeatActivePlayerStrokeMargin,
            StaticData.videoSeatSizes.x + StaticData.videoSeatActivePlayerStrokeMargin * 2,
            StaticData.videoSeatSizes.y + StaticData.videoSeatActivePlayerStrokeMargin * 2,
            StaticData.videoSeatActivePlayerStrokeBorderRadius + StaticData.videoSeatActivePlayerStrokeMargin - StaticData.videoSeatBorderWidth / 2
        );
    }
}
